import { Component, Input } from '@angular/core'
import {
    AccordionFragment,
    AccountManagerFragment,
    AssetFragment,
    AssetsFragment,
    CarouselFragment,
    ContentCategoriesFragment,
    CtaLinkFragment,
    ImageWithTextHeaderFragment,
    ImageContentLinkFragment,
    ImageHeaderFragment,
    ImageMosaicFragment,
    ImagePositionEnum,
    ImageTextFragment,
    ImageWithTextFragment,
    FormTypeEnum,
    FormFragment,
    MapFragment,
    NewsLetterFragment,
    PageLinksFragment,
    ParagraphFragment,
    ParagraphsCarouselFragment,
    ParagraphsFragment,
    ProjectShowCaseFragment,
    ProjectSlideFragment,
    QuoteFragment,
    QuotesFragment,
    StatisticsFragment,
    SubFooterLinkFragment,
    TextHeaderFragment,
    UniqueSellingPointFragment,
    UniqueSellingPointsFragment,
    VideoHeaderFragment,
    VideoTextFragment,
    VideoWithTextFragment,
} from '@app-graphql/schema'

type AnyComponent =
    | AccordionFragment
    | AccountManagerFragment
    | AssetsFragment
    | CarouselFragment
    | ContentCategoriesFragment
    | CtaLinkFragment
    | ImageContentLinkFragment
    | ImageHeaderFragment
    | ImageMosaicFragment
    | ImageWithTextHeaderFragment
    | ImageTextFragment
    | ImageWithTextFragment
    | FormFragment
    | MapFragment
    | NewsLetterFragment
    | PageLinksFragment
    | ParagraphsFragment
    | ParagraphsCarouselFragment
    | ProjectShowCaseFragment
    | QuotesFragment
    | StatisticsFragment
    | SubFooterLinkFragment
    | TextHeaderFragment
    | UniqueSellingPointsFragment
    | VideoHeaderFragment
    | VideoTextFragment
    | VideoWithTextFragment

@Component({
    selector: 'app-page-component-identifier',
    templateUrl: './page-component-identifier.component.html',
})

export class PageComponentIdentifierComponent {

    public accordion: AccordionFragment
    public accountManager: AccountManagerFragment | null = null
    public assets: AssetFragment[] | null = null
    public carousel: CarouselFragment | null = null
    public categories: ContentCategoriesFragment
    public ctaLink: CtaLinkFragment | null = null
    public imageContentLink: ImageContentLinkFragment
    public imageHeader: ImageHeaderFragment | null = null
    public imageMosaic: ImageMosaicFragment | null = null
    public imageText: ImageTextFragment | null = null
    public imageWithText: ImageWithTextFragment | null = null
    public imageTextHeader: ImageWithTextHeaderFragment
    public isContactForm: boolean = false
    public isDataRequestForm: boolean = false
    public map: MapFragment
    public newsLetter: NewsLetterFragment
    public pageLinks: PageLinksFragment
    public paragraphCarousel: ParagraphFragment[] | null = null
    public paragraphs: ParagraphsFragment
    public projectShowcaseSlides: ProjectSlideFragment[]
    public projectShowcases: ProjectShowCaseFragment | null = null
    public quotes: QuoteFragment[] | null = null
    public stats: StatisticsFragment | null = null
    public subFooterLink: SubFooterLinkFragment | null = null
    public textHeader: TextHeaderFragment | null = null
    public uniqueSellingPoints: UniqueSellingPointFragment[] | null = null
    public videoHeader: VideoHeaderFragment | null = null
    public videoText: VideoTextFragment | null = null
    public videoWithText: VideoWithTextFragment | null = null

    public firstComponentOfPage: string

    protected readonly ImagePositionEnum = ImagePositionEnum

    @Input()
    public set firstComponent(component: AnyComponent) {
        this.firstComponentOfPage = component.__typename
    }

    @Input()
    public set data(data: AnyComponent) {
        this.processAnyComponent(data)
    }

    private processAnyComponent(data: AnyComponent): void {
        switch (data.__typename) {
            case 'Paragraphs':
                this.paragraphs = data
                break
            case 'ProjectShowCase':
                this.projectShowcases = data
                this.projectShowcaseSlides = [...data.slides]
                break
            case 'ImageHeader':
                this.imageHeader = data
                break
            case 'ParagraphsCarousel':
                this.paragraphCarousel = [...data.paragraphs]
                break
            case 'TextHeader':
                this.textHeader = data
                break
            case 'VideoHeader':
                this.videoHeader = data
                break
            case 'Quotes':
                this.quotes = [...data.quotes]
                break
            case 'Statistics':
                this.stats = data
                break
            case 'UniqueSellingPoints':
                this.uniqueSellingPoints = [...data.uniqueSellingPoints]
                break
            case 'ImageWithText':
                this.imageWithText = data
                break
            case 'VideoWithText':
                this.videoWithText = data
                break
            case 'Carousel':
                this.carousel = data
                break
            case 'AccountManager':
                this.accountManager = data
                break
            case 'CtaLink':
                this.ctaLink = data
                break
            case 'Form':
                if (data.type === FormTypeEnum.DataRequest) {
                    this.isDataRequestForm = true
                } else {
                    this.isContactForm = true
                }

                break
            case 'ImageMosaic':
                this.imageMosaic = data
                break
            case 'ImageText':
                this.imageText = data
                break
            case 'SubFooterLink':
                this.subFooterLink = data
                break
            case 'VideoText':
                this.videoText = data
                break
            case 'Map':
                this.map = data
                break
            case 'NewsLetter':
                this.newsLetter = data
                break
            case 'ImageContentLink':
                this.imageContentLink = data
                break
            case 'Categories':
                this.categories = data
                break
            case 'Accordion':
                this.accordion = data
                break
            case 'PageLinks':
                this.pageLinks = data
                break
            case 'Assets':
                this.assets = [ ...data.assets ]
                break
            case 'ImageWithTextHeader':
                this.imageTextHeader = data
                break
        }
    }
}
